import { create } from 'zustand'

export type OlarkHelperState = {
  isOlarkBoxOpen?: boolean
  isConversationActive?: boolean
  loadId?: string | null
  lastPjChatId?: string | null
}
type Actions = {
  update: (state: Partial<OlarkHelperState>) => void
}
type StateWithActions = OlarkHelperState & { actions: Actions }
const initialState: OlarkHelperState = {
  isOlarkBoxOpen: false,
  isConversationActive: false,
  loadId: undefined,
  lastPjChatId: undefined,
}

export const useOlarkStore = create<StateWithActions>(set => ({
  ...initialState,
  actions: {
    update(state) {
      set(prev => ({ ...prev, ...state }))
    },
  },
}))
